import { BinaryClient } from "../../../../apis/mlmbox/client/binary/v1/binary_grpc_web_pb";
import { SearchRequest, SettingsSideSetRequest } from "../../../../apis/mlmbox/client/binary/v1/binary_pb";
import { Empty } from 'google-protobuf/google/protobuf/empty_pb.js'
import { API_URL } from '@/api';

const client = new BinaryClient(API_URL, null, {
    withCredentials: true
});

export default {
    state: {
        info: {},
        binarySearchResults: [],
        settingsSide: [],
    },
  
    mutations: {
        setBinaryInfo(state, info) {
            state.info = info;
        },

        setBinarySearchResults(state, binarySearchResults) {
            state.binarySearchResults = binarySearchResults;
        },

        setSettingsSide(state, settingsSide) {
            state.settingsSide = settingsSide;
        },
    },
 
    actions: {
        getBinaryInfo({commit}) {
            return new Promise((resolve, reject) => {
                const request = new Empty;
      
                client.info(request, {"authorization": localStorage.getItem("access_token")}, (err, response) => {
                    if (err !== null) {
                        reject(err)
                    } else {
                        commit('setBinaryInfo', response.toObject())
                        resolve(response.toObject())
                    }
                })
            })
        },

        searchBinary({commit}, { loginPrefix }) {
            return new Promise((resolve, reject) => {
                const request = new SearchRequest();

                request.setLoginPrefix(loginPrefix);
      
                client.search(request, {"authorization": localStorage.getItem("access_token")}, (err, response) => {
                    if (err !== null) {
                        reject(err)
                    } else {
                        commit('setBinarySearchResults', response.toObject())
                        resolve(response.toObject())
                    }
                })
            })
        },

        setSettingsSide({commit}, { userSide }) {
            return new Promise((resolve, reject) => {
                const request = new SettingsSideSetRequest();

                request.setUserSide(userSide);
      
                client.settingsSideSet(request, {"authorization": localStorage.getItem("access_token")}, (err, response) => {
                    if (err !== null) {
                        reject(err)
                    } else {
                        commit('setSettingsSide', response.toObject())
                        resolve(response.toObject())
                    }
                })
            })
        },

        // getCareerRank({ commit }, rankId) {
        //     return new Promise((resolve, reject) => {
        //         const request = new Career.Rank.ID();

        //         request.setRankId(rankId)
      
        //         client.rankGet(request, {"authorization": localStorage.getItem("access_token")}, (err, response) => {
        //             if (err !== null) {
        //                 reject(err)
        //             } else {
        //                 commit('setRank', response.toObject())
        //                 resolve(response.toObject())
        //             }
        //         })
        //     })
        // },

        // getCareerRankAll({commit}) {
        //     return new Promise((resolve) => {
        //         const request = new Empty;
        //         const stream = client.packagesAll(request, {"authorization": localStorage.getItem("access_token")})

        //         stream.on('data', function(response) {
        //             resolve(response.toObject())
        //             commit('setRankAll', response.toObject())
        //         });
        //     })
        // },
    }
}